<template>
  <v-row no-gutters class="fill-height flex-column" style="overflow-y: auto; overflow-x: hidden;">
    <v-col cols="12">
      <card-title-row :straightTitle="$i18n.t('sidebar.zdmSelectionReport.title')" class="py-6" />
      <sidebar-row>
        <base-button-subheader subheader-translation-path="sidebar.zdmSelectionReport.selectAreaSubtitle">
          <dots-menu :items="dotsItems" @multiple="turnOnDrawing('multiple')" @freehand="turnOnDrawing('freehand')">
            <template #activator="{ on }">
              <base-button
                :disabled="isDone"
                v-on="getButtonListeners(on)"
                class="mr-0"
                translation-path="sidebar.zdmSelectionReport.selectArea"
                :button-style="buttonStyle"
              />
            </template>
          </dots-menu>
        </base-button-subheader>
      </sidebar-row>
      <sidebar-row v-if="isDone">
        <v-row class="py-5" no-gutters>
          <v-tooltip :disabled="Boolean(currentUserEmail)" color="font" top>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-checkbox
                  v-model="payload.send_email"
                  class="py-0 my-0"
                  :disabled="!Boolean(currentUserEmail) || loading"
                  hide-details
                >
                  <template #label>
                    <v-row
                      :style="`color: ${currentUserEmail ? 'rgba(0, 0, 0, 0.87)' : ''}; font-size: 14px`"
                      no-gutters
                    >
                      {{ $i18n.t('sidebar.zdmSelectionReport.sendEmail') }}
                    </v-row>
                  </template>
                </v-checkbox>
              </span>
            </template>
            <span>{{ $i18n.t('sidebar.zdmSelectionReport.noEmailAddress') }}</span>
          </v-tooltip>
        </v-row>
        <v-row style="gap: 1rem 0">
          <v-col cols="auto" class="py-0">
            <base-button
              :loading="loading"
              class="mr-0"
              translation-path="sidebar.zdmSelectionReport.generateReport"
              @click="handleGenerateReport"
            />
          </v-col>
          <v-col cols="auto" class="py-0">
            <base-button
              cancel
              :disabled="loading"
              translation-path="sidebar.zdmSelectionReport.clearSelection"
              @click="clearSelection"
            />
          </v-col>
        </v-row>
      </sidebar-row>
    </v-col>
  </v-row>
</template>

<script>
import CardTitleRow from '@/components/CardTitleRow';
import SidebarRow from '@/components/SidebarRow';
import DotsMenu from '@/components/DotsMenu';

import { createBox } from 'ol/interaction/Draw';

import { call, get } from 'vuex-pathify';

export default {
  name: 'ZDMSelectionReportSidebar',
  components: {
    CardTitleRow,
    SidebarRow,
    DotsMenu,
  },
  data: () => ({
    loading: false,
    payload: {
      geometry: undefined,
      srid: undefined,
      send_email: false,
    },
    isDone: false,
    isDrawing: false,
    dotsItems: [
      {
        name: 'multiple',
      },
      {
        name: 'freehand',
      },
    ],
    currentTaskId: null,
  }),
  computed: {
    currentUserEmail: get('users/currentUser.email'),
    buttonStyle() {
      return this.isDrawing
        ? {
            backgroundColor: `${this.$_colors.primarybackground} !important`,
            border: '1px solid rgba(26, 115, 232, 0.3) !important',
            color: this.$_colors.primary,
          }
        : {
            backgroundColor: 'rgba(0, 0, 0, 0.04) !important',
            border: '1px solid rgba(0, 0, 0, 0.2) !important',
            color: '#61646D',
          };
    },
  },
  methods: {
    getObjectsReportId: call('zdm/getObjectsReportId'),
    stopCeleryTask: call('celeryTasks/stopCeleryTask'),
    turnOffSelecting() {
      this.isDrawing = false;
      this.$root.$emit('selection-action');
    },
    getButtonListeners(on) {
      return this.isDrawing
        ? {
            click: this.turnOffSelecting,
          }
        : on;
    },
    clearSelection() {
      this.isDrawing = false;
      this.isDone = false;
      this.$root.$emit('clearSidebarGeometry');
    },
    onDrawend(e) {
      this.isDrawing = false;
      this.isDone = true;
      this.payload = {
        srid: this.$_config.defaultEpsg.split(':')[1],
        geometry: {
          type: 'Feature',
          geometry: {
            type: e.feature.getGeometry().getType(),
            coordinates: e.feature.getGeometry().getCoordinates(),
          },
          properties: {},
        },
      };
    },
    turnOnDrawing(type) {
      this.isDrawing = true;
      this.$root.$emit('drawSidebarGeometry', {
        drawendCallback: this.onDrawend,
        geometryFunction: type === 'multiple' ? createBox() : null,
        geometryType: 'polygon',
        isInitSnapping: false,
        freehand: type === 'freehand' ? true : false,
        ...(type === 'multiple' ? { drawType: 'Circle' } : {}),
      });
    },
    async handleGenerateReport() {
      try {
        this.loading = true;
        this.currentTaskId = await this.getObjectsReportId(this.payload);
        this.$globalHub.$emit('handleCeleryTask', {
          currentTaskId: this.currentTaskId,
          taskStartSnackbar: {
            message: this.$i18n.t('snackbar.generatingReport'),
          },
          taskFailureSnackbar: {
            message: this.$i18n.t('errors.backend.requestError'),
            timeout: -1,
          },
          taskFailureCallback: this.generateReportResultCallback,
          taskSuccessCallback: this.generateReportResultCallback,
        });
      } catch (error) {
        this.generateReportResultCallback();
        console.log('error', error);
      }
    },
    generateReportResultCallback() {
      this.currentTaskId = null;
      this.loading = false;
    },
  },
  beforeDestroy() {
    if (this.currentTaskId) {
      this.stopCeleryTask(this.currentTaskId);
    }
    this.clearSelection();
    if (this.isDrawing) {
      this.turnOffSelecting();
    }
  },
};
</script>
